export const convertArrayToLowerCase = (array: string[]): string[] => {
  return array.map((item) => item.toLowerCase())
}
